
// Import module styles.
import "./create.view.less";

// Define controllers.
window.vyykfq = {
	FormController
};

function FormController() {

	var host = this.$el;
	var prompts = host.querySelectorAll( ".prompt-info" );

	return {
		init: $init,
		syncInfoNodes: syncInfoNodes
	};

	// ---
	// PUBLIC METHODS.
	// ---

	/**
	* I initialize the form component.
	*/
	function $init() {

		this.syncInfoNodes();

	}

	/**
	* I synchronize the prompt info rendering with the select.
	*/
	function syncInfoNodes() {

		var value = this.$refs.select.value;

		for ( var prompt of prompts ) {

			prompt.classList.remove( "is-active" );

			if ( prompt.dataset.promptId === value ) {

				prompt.classList.add( "is-active" );

			}

		}

	}

}
